import { render, staticRenderFns } from "./WaterEquipmentView.vue?vue&type=template&id=524eb503&scoped=true&"
import script from "./WaterEquipmentView.vue?vue&type=script&lang=js&"
export * from "./WaterEquipmentView.vue?vue&type=script&lang=js&"
import style0 from "./WaterEquipmentView.vue?vue&type=style&index=0&id=524eb503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524eb503",
  null
  
)

export default component.exports